import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlug } from '@fortawesome/pro-regular-svg-icons/faPlug';

// FontAwesome regular (outlined) plug icon. Wrapped to match the
// component-with-no-props contract NavIcon expects.
//
// The compound selector below (`.svg-inline--fa` is FA's own class) bumps
// specificity above NavIconBox's `svg { height: 16px }` rule so this icon
// can render larger than the default nav icon size.
const StyledIcon = styled(FontAwesomeIcon)`
  &.svg-inline--fa {
    height: 18px;
    width: 18px;
  }
`;

export default function Plug() {
  return <StyledIcon icon={faPlug} />;
}
